import classes from "./ProductOptions.module.scss";

const ProductOptions = ({ options, handleOptionChange, selectedVariant }) => {
  return (
    <>
      {options && options.length > 0 && options.map((option, i) => (
        <div key={option.name} className={classes['options-wrapper']}>
          <label className={classes['options-label']}>
            CHOOSE YOUR SIZE:
          </label>
          <div className={classes['options-inline']}>
            {option.values.map((value) => {
              const isSelected = selectedVariant.content?.selectedOptions
                .some(o => o.name === option.name && o.value === value);

              return (
                <button
                  key={value}
                  type="button"
                  className={`${classes['options-button']} ${
                    isSelected ? classes['options-button--active'] : ''
                  }`}
                  onClick={() => handleOptionChange(value, option)}
                >
                  {option.name === 'amount' ? `$${value}` : value}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </>
  );
};

export default ProductOptions;